import React from "react";
import QuoteForm from "../components/QuoteForm";
import { useTranslation, Trans } from "react-i18next";

export default function Contact() {
  const { t } = useTranslation();

  return (
    <main className="min-h-screen bg-gradient-to-b from-[#0b0d12] to-[#0a0b10]">
      <section className="mx-auto max-w-4xl px-4 py-16">
        <header className="mb-8">
          <h1 className="text-3xl font-bold text-white">
            {t("contact.page_title")}
          </h1>

          {/* Use Trans so <b> renders as an element, not text */}
          <p className="mt-2 max-w-2xl text-sm text-gray-400">
            <Trans
              i18nKey="contact.page_desc"
              values={{ email: "andreitechro@gmail.com" }}
              components={{ b: <b /> }}
            />
          </p>
        </header>

        <QuoteForm />

        <footer className="mt-10 text-center text-xs text-gray-500">
          {t("contact.footer.note")}
        </footer>
      </section>
    </main>
  );
}
